var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { isEmpty } from "lodash";
import { BasketItemType } from "@irati/types";
import basket from "@irati/checkout/utils/basket";
import MultipleProductSelection from "../../../components/ProductForms/MultipleProductSelection";
var MultipleProducts = /** @class */ (function (_super) {
    __extends(MultipleProducts, _super);
    function MultipleProducts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleUpdateQuantity = function (type, productId) {
            var _a;
            var deal = _this.props.deal;
            var count = ((_a = basket.items.find(function (t) { return t.productId === productId; })) === null || _a === void 0 ? void 0 : _a.count) || 0;
            if (type === "+") {
                count++;
            }
            else {
                count--;
            }
            basket.setProduct(BasketItemType.Deal, deal.uuid, productId, { count: count });
        };
        return _this;
    }
    MultipleProducts.prototype.render = function () {
        return (React.createElement(MultipleProductSelection, { deal: this.props.deal, products: this.props.products, handleClick: this.handleUpdateQuantity, isLoading: isEmpty(this.props.products) }));
    };
    return MultipleProducts;
}(Component));
export default MultipleProducts;
